import { useContext, useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { makeStyles } from "@material-ui/core/styles";
import { i18n } from "../../../translate/i18n";
import toastError from "../../../errors/toastError";
import { Grid, Button, TextField, Dialog, DialogActions, DialogContent, DialogTitle, Typography, Select, MenuItem, Tooltip } from "@material-ui/core";
import HelpIcon from '@material-ui/icons/Help';
import api from "../../../services/api";

const useStyles = makeStyles(theme => ({
    root: {
        display: "flex",
        flexWrap: "wrap",
    },
}));

const ProductAndServiceStoreModal = ({ open, onClose, productAndServiceId }) => {

    const classes = useStyles();

    const initialState = {
        name: null,
    };
    const [productAndService, setProductAndService] = useState(initialState);

    useEffect(() => {
        if (!open || !productAndServiceId) return;
        let isMounted = true;
        const abortController = new AbortController();

        (async () => {
            try {
            	const { data } = await api.get(`/customerRelationship/productAndService/${productAndServiceId}`, {
                    signal: abortController.signal,
                });
                if (!isMounted) return;
                if (data.productAndService) {
                    setProductAndService(prevState => {
                        return { ...prevState, ...data.productAndService };
                    });
                }
            } catch (err) {
                if (!isMounted || err.name == 'AbortError') return;
            	console.error({err});
            	toastError(err);
            }
        })();

        return () => {
            isMounted = false;
            abortController.abort();
        };

    }, [open]);

    const handleClose = (event, reason) => {
        if (reason == 'backdropClick') {
            event.preventDefault();
            return;
        }

        onClose();
        setProductAndService(initialState);
    };

    const handleSave = async () => {
        try {
            if (!productAndService.name || productAndService.name == '') { toastError({ response: { data: { error: i18n.t('customerRelationship.configuration.productAndService.messages.nameRequired') } } }); return; }

            if (productAndServiceId) {
                await api.put(`/customerRelationship/productAndService/update/${productAndServiceId}`, { ...productAndService });
            } else {
                await api.post(`/customerRelationship/productAndService/create`, { ...productAndService });
            }

            toast.success(i18n.t('backendSuccess.SAVED_SUCCESSFULLY'));
            handleClose();
        } catch (err) {
            console.error({ err });
            toastError(err);
        }
    }

    return (
        <div className={classes.root}>
            <Dialog
                open={open == true ? true : false}
                onClose={(event, reason) => handleClose(event, reason)}
                scroll="paper"
                fullWidth="sm"
                maxWidth="sm"
                disableEscapeKeyDown={true}
            >
                <DialogTitle>
                    {i18n.t('customerRelationship.configuration.productAndService.title')}
                </DialogTitle>
                <DialogContent style={{ padding: "0 25px", height: "50vh", overflowY: "auto" }}>
                    <Grid container spacing={1} style={{ marginBottom: "10px" }}>
                        <Grid item sm={12} xs={12} mb={3}>
                            <Typography component="label">
                                {i18n.t('customerRelationship.configuration.productAndService.form.name')}
                                <Typography component="span" className="text-danger ml-2">*</Typography>
                            </Typography>
                            <TextField
                                id="crmProductAndServiceName"
                                key="crmProductAndServiceName"
                                placeholder={i18n.t('customerRelationship.configuration.productAndService.form.name')}
                                variant="outlined"
                                style={{ marginTop: "10px" }}
                                value={productAndService.name || null}
                                fullWidth
                                inputProps={{ maxLength: 50 }}
                                size="small"
                                onChange={(e) => setProductAndService({ ...productAndService, name: e.target.value })}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={handleClose}
                        color="secondary"
                        variant="outlined"
                    >
                        {i18n.t("buttons.close")}
                    </Button>
                    <Button
                        onClick={handleSave}
                        color="primary"
                        variant="contained"
                    >
                        {i18n.t("buttons.save")}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default ProductAndServiceStoreModal;